import { useCallback } from 'react';

import { refreshToken } from '@/api/api';
// import Token from '@/utils/handlers/Token';
// import { useQueryClient } from '@common-fe/common-fe';

export default () => {
  // const queryClient = useQueryClient();
  const handleRefreshToken = useCallback(async () => {
    try {
      await refreshToken();
      // eslint-disable-next-line no-empty
    } catch {}
  }, []);
  return {
    handleRefreshToken,
  };
};
